// extracted by mini-css-extract-plugin
module.exports = {"albumFolder":"ArtistEditorRow-albumFolder-3o-Ct TableRowCell-cell-2fbg4"};